/**
 * Creates a HoC which wraps the FeatureFlag Consumer and provides extra functionality for checking flags
 */
import PropTypes from 'prop-types'
import Context from './FeatureFlags.context'
import * as consts from './featureFlags.constants'

export const getAvailableFeatureFunction = featureFlagsConfig => flag => {
  if (featureFlagsConfig.launchDarklyProps && featureFlagsConfig.launchDarklyProps.implementation === consts.PROPERTY_FILE_IMPLEMENTATION) {
    const fileProps = featureFlagsConfig.launchDarklyProps.properties
    return fileProps[flag] ? fileProps[flag] === 'true' : false
  } else if (featureFlagsConfig.launchDarklyProps && featureFlagsConfig.launchDarklyProps.implementation === consts.LAUNCHDARKLY_IMPLEMENTATION) {
    return featureFlagsConfig.featureFlagClient && featureFlagsConfig.featureFlagClient.variation(flag, false)
  } else {
    return false
  }
}

export const getFeatureFlags = () => {
  return Context.Consumer
}

export const createCanUseFeature = featureFlagsConfig => ({
  canUseFeature: getAvailableFeatureFunction(featureFlagsConfig),
})

// Using named functions to avoid "Component definition is missing display name" error
// https://github.com/yannickcr/eslint-plugin-react/issues/597#issuecomment-407567001
function withFeatureFlags(ComposedComponent) {
  return function WrappedConsumer(props) {
    return (
      <Context.Consumer>
        {value => <ComposedComponent {...props} canUseFeature={getAvailableFeatureFunction(value)} />}
      </Context.Consumer>
    )
  }
}

withFeatureFlags.propTypes = {
  ComposedComponent: PropTypes.node.isRequired,
}

export default withFeatureFlags
